<template>
  <div>
    <div style="padding-bottom:20px;cursor:pointer" @click="triggerHide">
      <h2 style="padding-right:10px;padding-bottom:5px;display:inline">{{ $t('common.stores') }}</h2>
      <svg-icon :hidden="!hide" :size="1.5" icon-class="arrow-right" />
      <svg-icon :hidden="hide" :size="1.5" icon-class="arrow-down" />
    </div>
    <div :hidden="hide">
      <pagination
        :page-sizes="[10, 20, 50, 100]"
        :pager-count="5"
        layout="pager, ->, total, sizes"
        :total="totalItems"
        :page.sync="listParams.page"
        :limit.sync="listParams.limit"
        @pagination="getFilteredAndPaginatedItems"
      >
      </pagination>
      <el-table
        ref="storeTable"
        :data="filteredAndPaginatedItems"
        border
        row-key="id"
        fit
        @select="rowSelected"
        @select-all="selectAllWithFilters"
        @selection-change="emitValues"
      >
        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}">
            <el-input
              v-model="filter['code']"
              class="search"
              size="mini"
              :placeholder="$t('store.code')"
              clearable
              prefix-icon="el-icon-search"
            />
          </template>
          <el-table-column :label="$t('store.code')" prop="code">
            <template slot-scope="scope">
              <span>{{ scope.row['code'] }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}">
            <el-input
              v-model="filter['name']"
              class="search"
              size="mini"
              :placeholder="$t('store.name')"
              clearable
              prefix-icon="el-icon-search"
            />
          </template>
          <el-table-column :label="$t('store.name')" prop="name">
            <template slot-scope="scope">
              <span>{{ scope.row['description'] || scope.row['name'] }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}">
            <Select
              v-model="filter['storeTypeID']"
              clearable
              :required="false"
              :placeholder="$t('store.type')"
              :options="storeTypes"
              value-field="id"
              label-field="name"
              class="search-select"
            />
          </template>
          <el-table-column :label="$t('store.type')" prop="name">
            <template slot-scope="scope">
              <span>{{ getStoreTypeFromRow(scope.row['storeTypeID']) }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}">
            <el-input-number
              v-model="filter['height']"
              type="number"
              class="search"
              size="mini"
              :placeholder="$t('store.height')"
              :controls="false"
              clearable
              prefix-icon="el-icon-search"
            />
          </template>
          <el-table-column :label="$t('store.height')" prop="name">
            <template slot-scope="scope">
              <span>{{ scope.row['height'] }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          reverse-selection="true"
          fixed="right"
          type="selection"
          width="40"
          align="center"
          :selectable="() => true"
        />
      </el-table>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import SvgIcon from '@/components/SvgIcon';
import Select from '@/components/DSE/Select';

export default {
  name: 'StoreTable',
  components: {
    Pagination,
    SvgIcon,
    Select
  },
  props: {
    domainID: {
      type: Number
    }
  },
  data() {
    return {
      loading: true,
      errorMsg: '',
      multipleSelection: [],
      filteredAndPaginatedItems: [],
      totalItems: 0,
      filter: {},
      hide: false,
      previousSelection: [],
      pageSwitched: false
    };
  },
  computed: {
    listParams() {
      return {
        page: this.page || 1,
        limit: this.pageSize || 10
      };
    },
    storeTypes() {
      return this.$store.getters['storeType/loadedItems'].filter(e => e.domainID === this.domainID);
    }
  },
  watch: {
    domainID() {
      this.$store.dispatch('store/getItems', { query: { domainid: this.domainID } }).then(data => {
        data.items.forEach(
          i => (i.friendlyDescription = i.description ? i.code + ', ' + i.description : i.code + ', ' + i.name)
        );
        this.page = 1;
        this.itemsForDomain = data.items;
        this.getFilteredAndPaginatedItems();
      });
    },
    filter: {
      deep: true,
      handler: function(value) {
        this.listParams.page = 1;
        this.getFilteredAndPaginatedItems();
      }
    }
  },
  created() {
    this.loading = false;
  },
  methods: {
    rowSelected(selection, row) {
      row.selectedYN = !row.selectedYN;
    },
    emitValues() {
      this.$emit('input', { showPanelStoreIDs: this.itemsForDomain.filter(i => i.selectedYN).map(i => i.id) });
    },
    triggerHide() {
      this.hide = !this.hide;
    },
    selectAllWithFilters() {
      const items = this.getFilteredItems();

      if (items.every(i => i.selectedYN)) {
        this.multipleSelection = [];
        items.forEach(i => {
          i.selectedYN = false;
          this.$refs.storeTable.toggleRowSelection(i, false);
        });
      } else {
        this.multipleSelection = items;
        items.forEach(i => {
          i.selectedYN = true;
          this.$refs.storeTable.toggleRowSelection(i, true);
        });
      }
      this.emitValues();
    },
    getStoreTypeFromRow(storeTypeID) {
      if (storeTypeID) {
        const storeType = this.$store.getters['storeType/loadedItems'].find(item => item.id === storeTypeID);
        return storeType.name;
      }
    },
    getFilteredAndPaginatedItems() {
      const items = this.getFilteredItems();

      if (items) {
        this.totalItems = items.length;

        // paginate
        const startIndex = (this.listParams.page - 1) * this.listParams.limit;
        const endIndex = startIndex + this.listParams.limit;
        this.filteredAndPaginatedItems = items.slice(startIndex, endIndex);

        // set selected items for new page
        this.$nextTick(() => {
          this.filteredAndPaginatedItems
            .filter(row => row.selectedYN)
            .forEach(row => this.$refs.storeTable.toggleRowSelection(row, true));
        });
      }
    },
    getFilteredItems() {
      let items = this.itemsForDomain;
      if (items) {
        // filter
        if (this.filter.code) {
          items = items.filter(i => i.code === this.filter.code);
        }
        if (this.filter.name && this.filter.name.length > 0) {
          const nameFilterLowerCase = this.filter.name.toLowerCase();
          items = items.filter(
            i =>
              (i.name && i.name.toLowerCase().includes(nameFilterLowerCase)) ||
              (i.description && i.description.toLowerCase().includes(nameFilterLowerCase))
          );
        }
        if (this.filter.storeTypeID) {
          items = items.filter(i => i.storeTypeID === this.filter.storeTypeID);
        }
        if (this.filter.height) {
          // eslint-disable-next-line eqeqeq
          items = items.filter(i => i.height && i.height == this.filter.height);
        }
      }

      return items;
    }
  }
};
</script>
